export default function showUsefulForm() {
  const yesButton = document.querySelector('.def-useful-panel__yes');
  const noButton = document.querySelector('.def-useful-panel__no');
  const formToggle = document.querySelector('.js-form-toggle');
  const formToggleYes = document.querySelector('.yesResponse');
  const formToggleNo = document.querySelector('.noResponse');

  if (yesButton) {
    // show form for YES button
    yesButton.addEventListener('click', function () {
      let noButtonActive = document.querySelector(
        '.def-useful-panel__no.active'
      );
      let formToggleNoActive = document.querySelector('.noResponse.active');

      // hide NO form if applicable
      if (noButtonActive) {
        noButtonActive.classList.remove('active');
        formToggle.classList.remove('active');
      }

      if (formToggleNoActive) {
        formToggleNoActive.classList.remove('active');
      }

      // toggle YES form
      yesButton.classList.toggle('active');
      formToggle.classList.toggle('active');
      formToggleYes.classList.toggle('active');
    });

    // show form for NO button
    noButton.addEventListener('click', function () {
      let yesButtonActive = document.querySelector(
        '.def-useful-panel__yes.active'
      );
      let formToggleYesActive = document.querySelector('.yesResponse.active');
      // hide YES form if applicable
      if (yesButtonActive) {
        yesButtonActive.classList.remove('active');
        formToggle.classList.remove('active');
      }
      if (yesButtonActive) {
        formToggleYesActive.classList.remove('active');
      }
      // toggle NO form
      noButton.classList.toggle('active');
      formToggle.classList.toggle('active');
      formToggleNo.classList.toggle('active');
    });
  }
}
